module.exports = __webpack_public_path__ + "static/media/IMG_1880.09e12d82.JPG";